import React from 'react';
import { FormGroup, Input, Label } from 'reactstrap';

import { IPlace } from 'types';
import { OtoSpinner } from '../common';

export type ReservationsPlaceSelectProps = {
  activePlace: IPlace | null;
  onActivePlaceChange: (place: IPlace | null) => void;
  places: IPlace[];
  isPlacesLoading: boolean;
};

export const ReservationsPlaceSelect: React.FC<ReservationsPlaceSelectProps> = ({
  activePlace,
  onActivePlaceChange,
  places,
  isPlacesLoading,
}) => {
  return (
    <FormGroup className="bb-1 bc-grey pb-3 mb-2">
      <Label className="font-weight-bold d-inline-flex align-items-center gap-5" htmlFor="activePlace">
        Aktywna sala
        {isPlacesLoading && <OtoSpinner size='sm' />}
      </Label>
      <Input
        type="select"
        className="mw-150"
        disabled={isPlacesLoading}
        id="activePlace"
        value={activePlace ? JSON.stringify(activePlace) : ''}
        onChange={(e) =>
          onActivePlaceChange(
            !!e.target.value ? (JSON.parse(e.target.value) as IPlace) : null
          )
        }
      >
        <option value="">wszystkie</option>
        {places.map((place) => (
          <option key={place.id} value={JSON.stringify(place)}>
            {place.name}
          </option>
        ))}
      </Input>
    </FormGroup>
  );
};

export default ReservationsPlaceSelect;
